export default {
  common: {
    cancel: 'Cancel',
    clear: 'Clear',
    confirm: 'Confirm',
    update: 'Update',
    downloading: 'Downloading ',
    models: 'Models',
    add: 'Add',
    create: 'Create',
    edit: 'Edit',
    rename: 'Rename',
    delete: 'Delete',
    move: 'Move',
    remove: 'Remove',
    duplicate: 'Duplicate',
    reset: 'Reset',
    share: 'Share',
    save: 'Save',
    done: 'Done',
    download: 'Download',
    first_name: 'First Name',
    last_name: 'Last Name',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    to: ' to ',
    verify: 'Verify',
    all: 'All',
    selectedOrg: 'Selected Organization',
    page: 'Page',
    loading: 'Loading...',
    my_projects: 'My Projects',
    team_projects: 'Team Projects',
    shared_projects: 'Shared Projects',
    current_task: 'Current Task',
    selected: 'Selected',
    unselect: 'Unselect',
    login: 'Login',
    search: 'Search',
    analyze: 'Analyze',
    title: 'Title',
    untitled: 'Untitled',
    checked: 'Checked',
    unchecked: 'Unchecked',
    link: 'Link',
    apply: 'Apply',
    role: 'Role',
    credits: 'Credits',
    credits_no: '{{count}} Credits',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
  },
  role: {
    owner: 'Owner',
    admin: 'Admin',
    manager: 'Manager',
    user: 'Member',
    member: 'Member',
  },
  country_code: {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, The Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Cote D'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and Mcdonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: "Korea, Democratic People's Republic of",
    KR: 'Korea, Republic of',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia, The Former Yugoslav Republic of',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States of',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    AN: 'Netherlands Antilles',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory, Occupied',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    SH: 'Saint Helena',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    CS: 'Serbia and Montenegro',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan, Province of China',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Viet Nam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis and Futuna',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
  notFound: {
    unauthorized: 'Oops! Unauthorized Access',
    notFound: 'Oops! Page not found',
    unauthorizedText: 'You are not authorized to access this page.',
    notFoundText: 'The page you are looking for does not exist.',
  },
  accessRequest: {
    title: 'You need access',
    subtitle: 'Request access, or switch to an account with access.',
    requestBtn: 'Request access',
    loginBtn: 'Login to request access',
    messagePlaceholder: 'Message (optional)',
    success: 'Access request sent successfully',
    error: 'Failed to send request. Please try again.',
    sending: 'Sending...',
    signedInAs: 'Signed in as',
    switchAccount: 'Switch account',
  },
  header: {
    mode: 'Mode',
  },
  menubar: {
    file: {
      toast: {
        download_original_file_error: 'Failed to download original file',
        no_model_file_available: 'No model file available',
      },
    },
    comments: 'Comments',
    details: 'Details',
    report: 'Report',
    quotation: {
      product_information: {
        product_information: 'Product Information',
        task_information: 'Task Information',
        title_label: 'Title',
        title_placeholder: 'Enter Title',
        title_error: 'Please enter a title',
        category_label: 'Category',
        category_placeholder: 'Select Category',
        category_error: 'Please select a category',
        subcategory_label: 'Subcategory',
        subcategory_placeholder: 'Select Subcategory',
        subcategory_error: 'Please select a subcategory',
        type_label: 'Type',
        subsubcategory_placeholder: 'Select Subcategory',
        subsubcategory_error: 'Please select a type',
        product: 'Product',
        reservation: 'Reservation',
        restaurant: 'Restaurant',
        hotel: 'Hotel',
        event: 'Event',
        other: 'Other',
        booking: 'Booking',
        quotation: 'Commercial',
        description_label: 'Description',
        description_placeholder: 'Share a quick description...',
        share_to_the_public: 'Share to the Public',
        share_to_gallery: 'Share to the O-HIVE Gallery',
        other_category_label: 'Custom category',
        other_category_placeholder: 'Enter a custom category',
      },
      product_price: {
        product_price: 'Product Price',
        price_label: 'Price',
        price_placeholder: '0.00     CAD',
        price_error: 'Please enter a price, you can also enter 0',
        other_cost_label: 'Other Cost',
        other_cost_description_label: 'Other Cost Description',
        other_cost_description_placeholder: 'Share Other Cost Description...',
        other_cost_placeholder: '0.00     CAD',
        policies_url_label: 'Policies URL',
        policies_url_placeholder: 'Paste URL',
        gst_hst_label: 'GST/HST',
        gst_hst_placeholder: '0   %',
        total_price_label: 'Total Price',
        total_price_placeholder: '0.00     CAD',
        total_price_error: 'Please enter a total price, you can also enter 0',
      },
      bom: {
        bom: 'Bill of Materials or Quote',
        add_item: 'Add item',
        delete_confirmation: 'Are you sure you want to delete this item?',
        bulk_delete_confirmation:
          'Are you sure you want to delete these {{count}} items?',
        category_management: {
          manage_grand_categories: 'Manage Grand Categories',
          manage_categories: 'Manage Categories',
          new_category_placeholder: 'New category name',
          select_all: 'Select All',
          total_price: 'Total Price',
          currency: {
            title: 'Select Currency',
            usd: 'USD',
            eur: 'EUR',
            gbp: 'GBP',
            jpy: 'JPY',
            cad: 'CAD',
            aud: 'AUD',
            cny: 'CNY',
            krw: 'KRW',
          },
        },
        table: {
          id: 'Item number',
          drag: 'Drag',
          include: 'Include',
          include_placeholder: 'Include?',
          no: 'NO',
          part_id: 'Part ID',
          part_id_placeholder: '#ID',
          product_name: 'Product Name',
          product_name_placeholder: 'Enter Product Name',
          grand_category: 'Grand Category',
          grand_category_placeholder: 'Enter Grand Category',
          category: 'Category',
          category_placeholder: 'Enter Category',
          description: 'Description',
          description_placeholder: 'Enter Description',
          manufacturer: 'Manufacturer',
          manufacturer_placeholder: 'Enter Manufacturer',
          address: 'Address',
          address_placeholder: 'Enter Address',
          model_number: 'Model Number',
          model_number_placeholder: 'Enter Model Number',
          quantity: 'Quantity',
          quantity_placeholder: 'Enter Quantity',
          unit_price: 'Unit Price',
          unit_price_placeholder: '20.00 USD',
          price: 'Price',
          price_inclusion_guidance:
            'Select the items you want to include in the price using the checkboxes in the table',
          price_placeholder: 'U/P x QTY',
          product_link: 'Link to Product',
          product_link_placeholder: 'Enter Link to Product',
          tag: 'Tag',
          tag_placeholder: 'Enter Tag',
          imageID: 'Image ID',
          imageID_placeholder: 'Enter Image ID',
        },
      },
      business_information: {
        point_of_contact: 'Point of Contact',
        first_name_label: 'First Name',
        first_name_placeholder: 'Enter First Name',
        last_name_label: 'Last Name',
        last_name_placeholder: 'Enter Last Name',
        business_information: 'Business Information',
        contact_information: 'Contact Information',
        business_address_label: 'Address',
        business_address_placeholder: 'Enter Address',
        business_address_error: 'Please enter Address',
        detailed_address_label: 'Detailed Address',
        detailed_address_placeholder: 'Enter More Detailed Address here',
        phone_label: 'Phone Number',
        phone_placeholder: 'Enter Phone Number',
        phone_error: 'Please enter a valid phone number',
        email_address_label: 'Email Address',
        email_address_placeholder: 'Enter Email Address',
        email_address_error: 'Please enter a valid email address',
        social_media_urls: 'Social Media URLs',
        facebook_url_placeholder: 'Enter Facebook URL',
        linkedin_url_placeholder: 'Enter LinkedIn URL',
        youtube_url_placeholder: 'Enter YouTube URL',
        instagram_url_placeholder: 'Enter Instagram URL',
        tiktok_url_placeholder: 'Enter Tiktok URL',
        other_links: 'Other Links',
        add_link: 'Add Link',
        link_name_placeholder: 'Enter Link Name',
        link_url_placeholder: 'Enter Link URL',
      },
      social_media: {
        facebook_label: 'Facebook',
        linkedin_label: 'LinkedIn',
        youtube_label: 'YouTube',
        instagram_label: 'Instagram',
        tiktok_label: 'TikTok',
      },
      buyer: {
        title_label: 'Title',
        title_placeholder: 'Enter Title',
        title_error: 'Please enter a title',
        fname_label: 'First Name',
        fname_placeholder: 'Enter First Name',
        fname_error: 'Please enter your first name',
        lname_label: 'Last Name',
        lname_placeholder: 'Enter Last Name',
        address_label: 'Address',
        address_placeholder: 'Enter Address Here',
        address_error: 'Please enter your address here',
        description_label: 'Description',
        description_placeholder: 'Enter Description',
        phone_label: 'Phone Number',
        phone_placeholder: 'Enter Phone Number',
        email_label: 'Email Address',
        email_placeholder: 'Enter Email address',
        submit_request: 'Submit Request',
      },
      point_of_contact: {
        address_label: 'Contact Address',
      },
      loading_pdf: 'Loading PDF...',
      export_pdf: 'Export as PDF',
      product_quotation: 'Product Quotation',
      untitled: 'Untitled Quotation',
      no_data_to_export: 'No quotation data to export',
      generating_pdf: 'Generating PDF...',
      pdf_exported: 'PDF exported successfully',
      pdf_font_error:
        'PDF font loading error. Please refresh the page and try again.',
      pdf_export_error: 'Error generating PDF. Please try again.',
      pdf_memory_error:
        'Document too large for PDF export. Try reducing BOM items.',
      no_significant_data:
        'No significant data found to export. Please add some content first.',
      subtotal: 'Subtotal:',
      vat: 'VAT',
      show_more: 'Show More',
      next: 'Next',
      confirmation_header: 'Do you want to proceed?',
      confirm_update_text: 'You are about to update this existing commercial.',
      confirm_create_text: 'You are about to create a new commercial.',
      processing_quotation: 'Processing Commercial...',
      updating_quotation: 'Updating Commercial...',
      confirmation_success_update_header:
        'Quotation has been successfully updated',
      confirmation_success_header: 'Commercial has been successfully created',
      confirmation_failed_update_header: 'Commercial has failed to be updated',
      confirmation_failed_update_subheader:
        'An error has occurred, please try again later...',
      validation_error: 'Please fill in all required fields',
      exit: 'Exit',
      continue: 'Continue',
      proceed: 'Proceed',
      back: 'Back',
      submit: 'Submit',
      no_quotation:
        'Project has no commercial yet, create one or contact your organization moderators',
      toast: {
        required_field_error: 'Please fill in all required fields: {{fields}}',
        validation_error: 'Please correct the following errors:: {{error}}',
        commercial_created: 'Commercial created successfully!',
        commercial_updated: 'Commercial updated successfully!',
        commercial_created_fail: 'Failed to create Commercial',
        commercial_updated_fail: 'Failed to update Commercial',
        commercial_prepare_fail: 'Failed to prepare Commercial data',
        error_show_confirm_modal: 'Error showing confirmation dialog',
      },
    },
    share: {
      share_title: 'Share',
      share_task: 'Sharing Task',
      share_project: 'Sharing Project',
      copy_link: 'Copy Link',
      url_copied: 'Share link copied!',
      general_access: 'General Access',
      option_restricted: 'Restricted',
      option_view: 'Member',
      option_member: 'Member',
      option_manager: 'Manager',
      option_admin: 'Admin',
      option_edit: 'Admin',
      public_private: 'Allow Public Access',
      public: 'Public',
      private: 'Private',
      who_access: 'Who can access ',
      add_people: 'Add people by typing name or email',
      change_comment_mode: 'Allow comments',
      invite: 'Invite',
      restricted: 'Restricted',
      revoke: 'Revoke',
      not_invited: 'Not Invited Yet',
      enabled: 'Enabled',
      disabled: 'Disabled',
      enable_public_access: 'Allow Public Access?',
      enable_public_access_description_task:
        'Anyone with the link will be able to view this model, even if they are not part of the organization. Ensure no sensitive data is shared.',
      enable_public_access_description_project:
        'Anyone part of the organization will be able to view this project. Ensure no sensitive data is shared.',
      toast: {
        access_level_changed: 'Access level changed to {{level}} successfully.',
        sending_invites: 'Sending invites...',
        cannot_invite_to_public_resource:
          'Cannot invite users to public resources without an organization',
        email_updated: 'Email updated successfully.',
        email_update_failed: 'Failed to update email. Please try again.',
        invalid_email: 'Invalid email',
        invalid_emails: 'Invalid email(s): {{emails}}',
        invites_sent: 'Invites sent successfully.',
        error_sending_invites: 'Error sending invites.',
        you_do_not_have_permission_to_invite_users:
          'You do not have permission to invite users.',
        please_add_at_least_one_email: 'Please add at least one email address.',
        error_sending_invites: 'Error sending invites.',
        invalid_email_format: 'Invalid email format: {{email}}',
        cannot_invite_yourself_to_resource:
          'You cannot invite yourself to the resource.',
        email_already_invited: 'Email {{email}} has already been invited.',
        email_already_in_pending_list:
          'Email {{email}} is already in the pending list.',
        please_add_at_least_one_email: 'Please add at least one email address.',
        toggle_comments_failed: 'Failed to toggle comments. Please try again.',
        comments_toggle_success: 'Comments {{status}} successfully.',
        access_level_failed: 'Failed to change access level. Please try again.',
        revoke_access_success: 'Successfully revoked access for {{email}}.',
        revoke_access_failed: 'Failed to revoke access for {{email}}.',
        role_update_success: 'Role updated successfully.',
        role_update_failed: 'Failed to update role. Please try again.',
        resource_not_found: 'Resource not found.',
        fetch_organization_warning:
          'No organization associated with this resource.',
        fetch_organization_error:
          'Failed to fetch organization users. Please try again later.',
      },
    },
  },
  applyReset: {
    toast: {
      fail: 'Failed to save model modification',
      success: 'Saved modified mesh to database',
      cancel: 'Mesh saving process cancelled',
      meshError: 'Mesh error: model has no valid triangles left!',
      cancelCrop: 'Mesh cropping process cancelled',
      failCrop: 'Mesh Cropping process failed',
    },
    buffer: {
      export3d: 'Exporting 3D model...',
      s3: 'Requesting upload location...',
      upload: 'Uploading file...',
      save: 'Finalizing save...',
      crop: 'Cropping model...',
    },
  },
  sidebar: {
    threads: 'Threads',
    camera: 'Camera',
    files: {
      title: 'Files',
      delete_title: 'Delete Objects',
      delete_description:
        'You are about to delete the selected objects. This process cannot be reversed.',
      uploaded: 'Uploaded',
      size: 'Size',
      add_file: 'Add File',
      empty_list: 'No files uploaded yet',
    },
    details: {
      title: 'Details',
      objects: {
        title: 'Objects',
        delete_object: 'Delete object',
      },
      cameras: {
        title: 'Cameras',
      },
    },
    reply: {
      add_mention: 'Mention',
      add_attachments: 'Attachments',
      check_ai_assistant: 'AI Assistant',
      post: 'Post',
    },
    comments: {
      title: 'Comments',
      add_title: 'Add Comment Title',
      empty: 'No comments',
      search_empty: 'No comments found',
      add_placeholder: 'Type comment...',
      add: 'Comment',
      edit: 'Edit comment',
      delete: 'Delete comment',
      reply: 'Reply',
      search_placeholder: 'Search tags and comments',
      add_tag: 'Add tag',
      single_comment: 'Comment',
      many_comments: 'Comments',
      disabled: 'Comments disabled',
      disabled_note: 'Comments are disabled for other users',
      no_access: 'You do not have access to comments',
      single_reply: 'View Reply',
      many_replies: 'View replies',
      replies: {
        edit: 'Edit reply',
        delete: 'Delete reply',
      },
      tasks: {
        backlog: 'In Backlog',
        inprogress: 'In Progress',
        inreview: 'In Review',
        complete: 'Complete',
        dropped: 'Dropped',
      },
      task_statusmarker: 'Status marker',
      task_assignedto: 'Assigned to',
      task_assignees: 'Assignees',
      task_duedate: 'Due Date',
      task_due: 'Due',
      task_istask: 'Treat it as a Task',
      task_nomemberfound: 'No members found',
      filter: {
        title: 'Filter',
        people: 'People',
        deadline: 'Deadline',
        status: 'Status',
        tag: 'Tag',
        clear: 'Clear Filter',
        apply: 'Apply Filter',
        orderBy: 'Order By',
        orderDirection: 'Order Direction',
        asc: 'Oldest First',
        desc: 'Newest First',
      },
    },
    tags: {
      title: 'Tags',
    },
    reports: {
      createTitle: 'Create Report',
      editTitle: 'Edit Report',
      description:
        'Please, enter report details. Following the * required to enter the information about the report.',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      mandatory: 'Mandatory',
      attachFile: 'Attach File From Library',
      generate: 'Collect Report Data',
      generate_newrep: 'Report History',
      generating: 'Collecting',
      no_assignee: 'Members were not assigned',
      save: 'Save Report',
      create_report: 'Save Report',
      history_report: 'Check Report History',
      unknown: 'Unknown',
      hint: 'Hint: "This Page" shows tasks on this page. "All Tasks" includes tasks within the entire project.',
      hint_2:
        'Hint: If press Generate the report you will see the amount of tasks that are on the tags ',
      subtitle: {
        no_results_found: 'No results found',
        no_choices: 'No choices to choose from',
        press_to_select: 'Press to select',
        only_unique_values: 'Only unique values can be added',
        only_matching: 'Only values matching specific conditions can be added',
      },
      status: {
        inBacklog: 'In Backlog',
        inProgress: 'In Progress',
        inReview: 'In Review',
        complete: 'Complete',
        dropped: 'Dropped',
      },
      tasks: {
        alltasks: 'All Tasks',
        currtasks: 'This Page',
      },
      types: {
        default: '-',
        body: 'Body Analysis',
        pose: 'Pose Analysis',
        progress: 'Progress Analysis',
      },
      keyPoints: {
        on: 'On',
        off: 'Off',
      },
      labels: {
        title: 'Title',
        subtitle: 'Subtitle',
        description: 'Description',
        session: 'Session',
        attachments: 'Attachments',
        status: 'Status',
        // assign: 'Assign member',
        dueDate: 'Due Date',
        reportType: 'Report Type',
        gender: 'Gender',
        age: 'Age',
        weight: 'Weight',
        height: 'Height',
        volume: 'Volume',
        waist: 'Waist',
        torsoHeight: 'Torso Height',
        shoulderLength: 'Shoulder Width',
        neckAngle: 'Neck Angle',
        leftArmLength: 'Arm (left)',
        rightArmLength: 'Arm (right)',
        waistToKneeLeftLength: 'Thigh (left)',
        waistToKneeRightLength: 'Thigh (right)',
        waistToToeLeftLength: 'Waist to Toe (left)',
        waistToToeRightLength: 'Waist to Toe (right)',
        chatGpt: 'AI Analysis',
        keyPoints: 'Key Points',
        shoulderAngleLeft: 'Shoulder Angle (left)',
        hipAngleLeft: 'Hip Angle (left)',
        shoulderAngleRight: 'Shoulder Angle (right)',
        hipAngleRight: 'Hip Angle (right)',
        elbowAngleLeft: 'Left Elbow Angle',
        elbowAngleRight: 'Right Elbow Angle',
        kneeAngleLeft: 'Left Knee Angle',
        kneeAngleRight: 'Right Knee Angle',
        waistAngleLeft: 'Waist Angle (left)',
        waistAngleRight: 'Waist Angle (right)',
        backlog: 'In Backlog',
        progress: 'In Progress',
        review: 'In Review',
        complete: ' Complete',
        dropped: 'Dropped',
      },
      placeholders: {
        title: 'Report Title',
        subtitle: 'Report Subtitle',
        description: "Report's Description",
        assignee: 'Member name',
        dueDate: 'YYYY/MM/DD',
        age: 'Add age',
        weight: 'Add weight',
        height: 'Add height',
        volume: 'Add volume',
        task: '',
        backlog: 'In Backlog',
        progress: 'In Progress',
        review: 'In Review',
        complete: 'Complete',
        dropped: 'Dropped',
      },
      toast: {
        report_saved: {
          title: 'Saved Successfully',
          description: 'Report {{title}} saved successfully.',
        },
        validate_report_error: {
          description:
            'An error occurred: Please ensure the {{culprit}} is properly filled.',
        },
      },
    },
    quotations: {
      title: 'Task Details',
      editTitle: 'Edit Task Details',
    },
    aiAnalyzer: {
      title: 'O-HIVE AI Assistant',
      assistant: 'Assistant',
      no_access: 'You do not have access to the labels creation',
      // textarea_placeholder: 'Add context (#), commands (/)',
      textarea_placeholder: 'Type commands (/)',
      chat_placeholder: 'Ask me anything...',
      new_chat: 'New Chat',
      loading_text: 'Analyzing...',
      mode: {
        work: 'Workspace',
        work_description: 'Best for tasks, files, and actions inside the app.',
        chat: 'Chat Mode',
        chat_description: 'Best for questions, ideas, and everyday help',
        detect: 'Detect',
        detect_description: 'Run visual detection on project images.',
      },
      detect_placeholder: 'Describe what to detect',
      detect: {
        select_image: 'Select image',
        change_image: 'Change image',
        upload_image: 'Upload image',
        select_from_project: 'Select from project',
        no_image: 'Select an image before running detection.',
        no_sequence: 'Create or select a sequence before running detection.',
        no_prompt: 'Describe what to detect.',
        result: 'Spatial Vision result',
        error: 'Detection failed. Please try again.',
      },
      quick_images: {
        current_task: 'Images from current task',
        current_project: 'Images from current project',
      },
      files_selected_limit: 'Limit of 10 selected files.',
      search_pdf: 'Search PDF files',
      projects_selected: '{{count}} projects selected',
      tasks_selected: '{{count}} tasks selected',
      no_projects_found: 'No projects found matching your search',
      no_projects_available: 'No projects available',
      no_tasks_found: 'No tasks found matching your search',
      no_tasks_in_project: 'No tasks available in this project',
      tasks_not_loaded: 'Browse to load tasks',
      task_count: '{{count}} task(s)',
      no_organization_projects: 'No organization projects available',
      no_pdf_found: 'No PDF files found matching your search',
      no_pdf_projects: 'No PDF files available in {{activeTab}} projects',
      time_unit: {
        minutes: 'minutes',
        seconds: 'seconds',
      },
      loading_text_estimated: 'Estimated time',
      pdfExport: {
        title: 'PDF export options',
        blueprint: 'Blueprint',
        blueprint_desc: 'Include the generated default blueprint SVG.',
        isometric: 'Isometric view',
        isometric_desc: 'Include a rendered PNG view of the active model.',
        no_model: 'Requires an active 3D model.',
        export: 'Export PDF',
        exporting: 'Exporting...',
      },
      toast: {
        download_success: 'PDF downloaded successfully',
        download_error: 'Failed to download PDF',
        blueprint_export_warning:
          'Blueprint generation failed. The PDF will continue without it.',
        isometric_export_warning:
          'Isometric view generation failed. The PDF will continue without it.',
        no_files_selected: 'No files selected',
        error: 'An error occurred while processing your request',
        no_prompt: 'Please write a prompt',
        bookmark_created: 'Bookmark created',
        copy_table_success: 'Table content copied to clipboard',
        copy_message_success: 'Message copied to clipboard',
        failed_to_refresh_bookmarks: 'Failed to refresh bookmarks',
        failed_to_load_bookmarks: 'Failed to load bookmarks',
        failed_to_load_history: 'Failed to load chat history',
        max_files_exceeded: 'Maximum number of files exceeded',
        insufficient_credits: 'Insufficient credits',
        insufficient_credits_text:
          'You have {{credits}} credit(s). At least 2 credits are required to run AI Analyzer.',
      },
      show_all: 'Show All',
      tabs: {
        chat: 'Chat',
        history: 'History',
        bookmarks: 'Bookmarks',
        projects: 'Projects',
        files: 'Files',
      },
      tooltip: {
        download: 'Export as PDF',
        bookmark: 'Bookmark',
        copy_table: 'Copy table content',
        copy_message: 'Copy to clipboard',
      },
      history_empty: 'No chat history available',
      bookmarks_empty: 'No bookmarks available',
      remove_bookmark_confirm: 'Are you sure you want to remove this bookmark?',
      remove_thread_confirm: 'Are you sure you want to remove this thread?',
      messages_count: 'Messages: {{count}}',
      select_all: 'Select All',
      deselect_all: 'Deselect All',
      no_search_results: 'No search results found.',
      credits_used: 'Credits used: {{credits}}',
      welcome_screen: {
        welcome_message: 'Hello, How can I help you?',
        // welcome_message:
        //   'Hello, How can I help you? You can request O-HIVE for performing any project management tasks.',
        tools: {
          project: {
            title: 'Projects',
            create_project: 'Create a new project named ',
            create_task: 'Create a new task named ',
            create_custom_column: 'Create a new custom column named ',
            create_task_report: 'Create a report from the task ',
          },
          files: {
            title: 'Documents',
            summarize: 'Summarize the selected files',
            create_report: 'Make a report from the selected files',
            compare_files: 'Make a comparison between the selected files',
          },
        },
        chat_tools: {
          general: {
            title: 'General',
            explain: 'Explain a concept to me',
            brainstorm: 'Help me brainstorm ideas',
            summarize: 'Summarize information for me',
          },
          shopping: {
            title: 'Shopping',
            product_recommendation: 'Recommend products for me',
            price_comparison: 'Compare prices for me',
            deal_finding: 'Find me the best deals',
          },
          travel: {
            title: 'Travel',
            flights: 'Find me flights',
            hotels: 'Find me hotels',
            places: 'Suggest places to visit',
          },
        },
      },
      voice_recognition: {
        mic_tooltip_idle: 'Voice input (Click to start/stop recording)',
        mic_tooltip_recording: 'Recording... (Click to stop)',
        mic_tooltip_start: 'Voice input (Click to start recording)',
        error_access_denied:
          'Microphone access denied. Please allow microphone access to use speech recognition.',
        error_no_speech: 'No speech detected. Please try again.',
        error_network: 'Network error occurred during speech recognition.',
        error_recognition_failed:
          'Speech recognition failed. Please try again.',
        error_not_supported:
          'Speech recognition not supported in this browser.',
        error_start_failed:
          'Failed to start speech recognition. Please try again.',
      },
    },
  },
  toolbar: {
    home: 'Home',
    capture: 'Capture',
    cursor: 'Cursor',
    select: 'Select',
    rotateleft: 'Rotate left',
    rotateright: 'Rotate right',
    translate: 'Translate',
    rotate: 'Rotate',
    scale: 'Scale',
    measure: 'Measure',
    tagDist: 'Tag Distance Measurement',
    tag: 'Tag',
    label: 'Label',
    topview: 'Top view',
    frontview: 'Front view',
    rightview: 'Right view',
    rearview: 'Rear view',
    draw: {
      title: 'Draw',
      color: 'Color',
      line: 'Line',
      draw: 'Draw',
      manage: 'Manage',
      clearConfirm: 'Are you sure you want to clear all drawings?',
    },
    robot: 'Robot',
    crop: 'Crop',
    tag_distance: 'Tag Distance',
    volume: 'Volume Mode',
    expand_tools: 'Expand Tools',
    collapse_tools: 'Collapse Tools',
    measurescale: 'Measure scale',
    immersion: 'Immersion Mode',
    blueprint: 'Blueprint Tool',
  },
  modal: {
    tag: {
      add_title: 'Add Tag Name',
      add_helper: 'Add Comment, Panorama, or a Link to the tag',
      tag_name: 'Tag Name',
      tag_name_placeholder: 'Enter tag name',
      comment_title: 'Comment',
      panorama_title: 'Panorama',
      comment_placeholder: 'Enter a comment',
      link_placeholder: 'Enter a link',
      edit_title: 'Edit tag',
      delete_title: 'Delete tag',
      add: 'Add tag',
      update: 'Update tag',
      delete: 'Delete tag',
      delete_question: 'Are you sure you want to delete this tag?',
      delete_nb_comments:
        'There {{isAre}} {{nb}} comment{{many}} attached to this tag',
      upload_panorama: 'Upload Panorama',
    },
    comment: {
      add_comment_placeholder: 'Add a comment',
      delete_question: 'Delete this comment?',
      reply_delete_question: 'Delete this reply?',
    },
    immersion: {
      title: 'Exit Immersion Mode?',
      msg: 'Would you like to exit immersion mode and return to the CAD viewer?',
      disconnect_msg: ' This will disconnect from multiplayer.',
      yes: 'Yes',
      no: 'No',
      loading: {
        avatar: 'Preparing 3D avatar...',
      },
    },
    taskDownload: {
      title: 'Download Models',
      text: 'Please select the models you want to download.',
      download: 'Download',
      downloading: 'Downloading',
      download_error: 'Failed to download models.',
      no_models: 'No models available for download',
      unknown_size: 'Unknown size',
    },
    joinCreateOrg: {
      title: 'Join or Create Organization',
      join_tab: 'Join Organization',
      create_tab: 'Create Organization',
      join_description:
        'Enter the organization ID to request to join an existing organization.',
      join_explanation:
        'You can get the organization ID from an existing member or administrator.',
      create_description:
        'Create a new organization and become its administrator.',
      org_id_label: 'Organization ID *',
      org_id_placeholder: 'Enter organization ID',
      org_name_label: 'Organization Name *',
      org_name_placeholder: 'Enter organization name',
      logo_label: 'Organization Logo (Optional)',
      message_label: 'Additional Message (Optional)',
      message_placeholder:
        'Add a message for the organization administrator...',
      send_request: 'Send Join Request',
      create_org: 'Create Organization',
      sending_request: 'Sending Request...',
      creating: 'Creating...',
      logo_formats: '• Supported formats: PNG, JPG, GIF',
      logo_size: '• Recommended size: 512x512px or larger',
      logo_uploaded: 'Logo uploaded successfully',
      invalid_image: 'Please select a valid image file',
      enter_org_id: 'Please enter an organization ID',
      enter_org_name: 'Please enter an organization name',
      request_sent:
        'Join request sent successfully! You will be notified when it is approved.',
      request_failed:
        'Failed to send join request. Please check the organization ID and try again.',
      org_created: 'Organization created successfully!',
      org_exists: 'An organization with this name already exists',
      user_has_org: 'You already have an organization',
      create_failed: 'Failed to create organization',
      request_error: 'An error occurred while sending the request',
      create_error: 'An error occurred while creating the organization',
    },
    rolesModal: {
      title: 'Organisation Role Details',
      role: 'Role',
      description: 'Description',
      current: 'Current',
      adminDescription: 'Full Access, Override Permissions',
      managerDescription: 'Full Task Access, Override Permissions',
      memberDescription: 'Access files within organisation, Invite users',
    },
    blueprint: {
      generate: 'Generate',
      description:
        'Create a 2D blueprint of the current model. This feature may not work on 3D objects other than rooms or building interiors.',
      meshError: 'Error: No meshes found.',
      loadingModel: 'Preparing model',
      loadingRay: 'Calculating ray grid',
      loadingRaycast: 'Raycasting',
      loadingLines: 'Generating lines',
      loadingBatch: 'Processing batch: ',
      calculating: 'Calculating...',
      generating: 'Generating blueprint...',
      estimate: 'Estimated processing time: ',
      warning:
        'Warning: large number of rays can potentially crowd the application memory!',
      seconds: ' seconds',
      error: 'Error',
      horizontalName: 'Horizontal steps',
      verticalName: 'Vertical steps',
      horizontalDesc:
        'More steps means finer horizontal object detection for thin objects such as poles.',
      verticalDesc:
        'More steps means finer vertical object detection for flat objects such as tables.',
      stepSizeName: 'Minimum step size',
      stepSizeDesc:
        'Lower size means more granular scanning at the cost of performance.',
      save: 'Save results to task',
      download: 'Automatically download blueprint',
    },
    move: {
      title: 'Move Task',
      allOrganizations: 'All Organizations',
      no_projects: 'No available projects to move to',
      loading: 'Loading projects...',
      error: 'Error loading projects. Please try again.',
      moving: 'Moving...',
      permission_or_subscription_missing:
        'Permission or subscription missing for this organization.',
    },
  },
  spaceModal: {
    welcome_message: 'Hi {{name}}! What would you like to work on today?',
    options: {
      collaboration: 'Collaboration',
      robotics: 'Robotics',
      later: 'I will decide later',
    },
    settings: 'You can change it anytime in your Settings',
  },
  resolutions: {
    original: 'Original',
    mobile: 'Mobile',
    medium: 'Medium',
  },
  panorama: {
    attachment_error: 'There was a problem',
  },
  detection: {
    sendDialog: {
      dialog:
        'Sending {{labels}} {{labelText}} across {{images}} {{imageText}} to {{dataType}} model "{{modelName}}".',
    },
    label: {
      singular: 'label',
      plural: 'labels',
    },
    image: {
      singular: 'image',
      plural: 'images',
    },
    object: {
      singular: 'object',
      plural: 'objects',
    },
    toast: {
      noImagesSelected: 'No images selected for processing.',
      selectModelFirst: 'Please select a model from the dropdown first.',
      noObjectsFound:
        'Detection complete, but no objects were found in any of the selected images.',
      detectionSuccess: 'Detection successful for {{count}} image{{s}}.',
      processCancelled: 'Detection process cancelled.',
      processingError: 'An unknown error occurred during processing.',
      noObjectsForImage: 'No objects were found for image {{imageId}}.',
      noValidObjects: 'No valid, non-overlapping objects were found.',
      objectsAdded: '{{count}} detected object{{s}} added to image.',
      clearingDetections: 'Clearing {{count}} previous detection{{s}}...',
      no_upload: 'No labeled images to upload.',
      upload_success: 'Successfully uploaded data for training.',
      upload_error: 'Upload failed.',
      upload_cancel: 'Upload cancelled.',
      model_limit_prefix: 'Model limit of',
      model_limit_suffix: 'has been reached.',
      empty_name: 'Model name cannot be empty.',
      model_exists: 'model name already exists.',
      reserved_name:
        '"Default Yolo" is a reserved name. Please choose a different name.',
      model_limit_reached: 'Model limit reached',
      upload_failed_detail: 'Upload failed. Please check the console.',
      compressing_files: 'Compressing files...',
      requesting_link: 'Requesting upload link...',
      uploading_cloud: 'Uploading to cloud storage...',
    },
    loading: {
      addingToArchive: 'Adding images to archive...',
      compressing: 'Compressing files...',
      requestingLink: 'Requesting upload link...',
      uploading: 'Uploading to cloud storage...',
      analyzing: 'Analyzing images with AI...',
    },
    ui: {
      noModelFound: 'No training model found.',
      detectButton: 'Detect',
      modelSelectPlaceholder: 'Choose AI Model',
      modelInfo: {
        type: 'Type: {{type}}',
        knownClasses: 'Known Classes: {{count}}',
        trainedOn: 'Trained on {{count}} image{{s}}',
        status: 'Status: {{status}}',
        trainingProgress: 'Status: Training ({{percent}}%)',
        uid: 'UID: {{uid}}',
      },
      imageText: 'Image List',
      noClasses: 'No classes found',
    },
  },
  canvas: {
    title: 'Canvas Options',
    background: {
      background: 'Background',
      title: 'Background Options',
      base_bg: 'Color',
      threeSixty_bg: 'Panorama',
      static_bg: 'Static',
      texture_file_support:
        'Supported image types: PNG, JPG, WEBP (Partial), GIF, BMP, TGA',
      texture_file_support_360:
        'Supported image types: PNG, JPG, WEBP (Partial), GIF, BMP, TGA - Be sure to use a panorama (360 degrees) image.',
      upload: 'Upload',
      add_file: 'Add File',
      file_success: 'File upload success',
      file_unknown: 'File format unrecognized, proceed with caution',
      file_none: 'No file detected',
      base_bg_desc:
        'Add a colored background according to your theme settings.',
      none_bg_desc: 'Remove all background effects.',
    },
    lighting: {
      lighting: 'Lighting',
      intensity: 'Intensity',
      visibility: 'Visibility',
      penumbra: 'Penumbra',
      angle: 'Angle',
      shadow: 'Shadow',
      distance: 'Distance',
      decay: 'Decay',
      position: 'Position',
      rotation: 'Rotation',
      scale: 'Scale',
      restore: 'Restore Default',
    },
    postProcessing: {
      renderEffects: 'Render Effects',
      postProcessing: 'Post-Processing',
      sceneHelpers: 'Scene Helpers',
      forceComposer: 'Use Composer',
      grid: 'Grid',
      horizontal: 'Horizontal Grid',
      vertical: 'Vertical Grid',
      adjustGrid: 'Placate grid to current model',
    },
    presets: {
      presets: 'Presets',
      presetsOhive: 'O-HIVE Presets',
      presetsDesc:
        "Customize your scene's lighting and environment settings according to the type of task you are viewing.",
      presetStudio: 'Studio Lights',
      presetMidnight: 'Midnight Flash',
      presetSnowy: 'Cold Alps',
      presetFactory: 'Factory Standard',
    },
    toast: {
      backgroundApplied: {
        title: 'Background Changed',
        description: 'Switched to {{mode}} background.',
      },
      updateBackgroundError: {
        title: 'Background Error',
        description: 'Error: {{error}}',
      },
      existingAmbient:
        'An Ambient Light already exists and is scene-wide. Only one is allowed.',
      defaultLightingRestored: 'Default lighting restored.',
    },
  },
  imageViewer: {
    carousel: {
      settings: {
        playSpeed: 'Playback Speed:',
        playDir: 'Play Direction:',
        left: 'Left',
        right: 'Right',
      },
    },
    uploadItems: {
      addNewItem: 'Add new items to ',
    },
    uploadImages: {
      addImages: 'Add Image(s)',
      deleteSelected: 'Delete Selected',
      warning: 'Warning: File(s) Type Unknown!',
      error: 'Error occurred during upload: ',
      errorAxios: 'Error uploading items to gallery: Axios Issue',
      files: 'files',
      noFiles: 'No files selected to add!',
      addFiles: 'Adding new image(s)...',
      success: 'Added images to gallery: ',
      upload: 'Upload',
    },
    uploadModels: {
      addModels: 'Add 3D Model(s)',
      deleteSelected: 'Delete Selected',
      warning: 'Warning: File(s) Type Unknown!',
      error: 'Error occurred during upload: ',
      errorAxios: 'Error uploading items to gallery: Axios Issue',
      files: 'files',
      noFiles: 'No files selected to add!',
      addFiles: 'Adding new model(s)...',
      success: 'Added models to gallery: ',
      upload: 'Upload',
    },
    objectDetectionFeature: {
      trainSucess: 'Your image data has been sent for training!',
      trainError:
        'No tagged image found for this CAD file to be sent for training!',
      enableDetection: 'Auto Detection Enabled',
      disableDetection: 'Auto Detection Disabled',
      defaultError: 'Something went wrong',
      downloadFailure: 'Failed to download model',
    },
    unknownFileType: {
      unsupported: 'Cannot display preview of unsupported file type',
      download: 'Download',
    },
    toast: {
      update_order: {
        title: 'Order Updated',
        description: 'Gallery updated.',
      },
      delete_images: {
        title: 'Images Deleted',
        description: 'Deleted {{count}} image(s) from current file.',
      },
      delete_images_match_error: {
        title: 'Match Error',
        description:
          'Error deleting image: Image Cad Id {imgCadId} and sprite Cad Id {spriteCadId} do not match.',
      },
    },
  },
  pages: {
    register: {
      title: 'Welcome to O-HIVE',
      subtitle: 'Please fill the fields below to create an account',
      confirm_password: 'Confirm Password',
      sign_up: 'Sign Up',
      no_account: "Don't have an account?",
      password_rules: {
        title: 'Password must contain:',
        uppercase: 'At least one uppercase letter',
        number: 'At least one number',
        special: 'At least one special character',
        length: 'At least 8 characters',
      },
      verify: {
        choose: 'Choose the verification option',
      },
      privacy: 'By registering, you agree to our',
      success:
        'You signed up successfully! Please check your authentication notification!',
      error: 'Ups! Something went wrong, please check your inputs!',
    },
    login: {
      title: 'Welcome Back',
      subtitle: 'Please sign in to continue',
      sign_in: 'Log In',
      already_have_account: 'Already have an account?',
      forgot_password: 'Forgot Password?',
      slogan1: 'Visualise Better. <br /> Collaborate Smarter.',
      slogan2:
        'All-in-one platform for visual colaboration, 3D scanning, AI-driven analysis, and real time project management',
      error: {
        credentials: 'Invalid email or password',
        toast: 'Ups! Something went wrong, please check your credentials!',
      },
      success: 'Login successfull!',
    },
    forgot_password: {
      title: 'Forgot Password?',
      subtitle: 'No worries we will send you reset instructions!',
      send: 'Send Reset Link',
      success: 'We sent you a link, please check your inbox!',
      error: 'Ups! Something went wrong, please check your email!',
    },
    reset_password: {
      title: 'Set new password',
      subtitle: 'Create a new password down below!',
      submit: 'Reset Password',
      success: 'Your new password is all set, please login again!',
      error:
        'Ups! Something went wrong, please check your password and token in the URL!',
    },
    phone_verify: {
      slogan1: 'Verify Your Phone',
      slogan2: 'Enter the code sent to your phone.',
      header: 'Phone Verification',
      sub_1: 'Enter the 6-digit code sent to',
      dont_get_code: "Didn't receive the code? ",
      send_again: 'Send again',
      success_message: 'Phone verified successfully!',
      error_invalid_code: 'Verification failed. Please check the code.',
      error_incomplete_code: 'Please enter the complete 6-digit code.',
      error_api: 'An unexpected error occurred.',
      resend_success: 'Verification code sent again.',
      resend_error: 'Failed to resend code.',
      missing_phone_params: 'Missing phone number parameter.',
    },
    email_verify: {
      slogan1: 'Verify Your Email Address',
      slogan2: 'Click the button below to verify your email.',
      header: 'Verify Your Email',
      verify_button: 'Verify Email',
      return_to_login: 'Return to Login',
      need_help: 'Need help? ',
      email_copied: 'Support email copied!',
      email_copied_error: 'Failed to copy email',
      success: 'Email verified successfully!',
      error: 'Email verification failed.',
      invalid_token: 'Invalid or expired verification link.',
      api_error: 'An unexpected error occurred.',
      processing: 'Verifying...',
    },
    projects: {
      project: 'Project',
      projects: 'Projects',
      task: 'Task',
      tasks: 'Tasks',
      noDescription: 'No description',
      createdOn: 'Created on',
      addTask: 'Add task',
      noTasksInProject: 'No tasks in this Project',
      createNewTask: 'Create New Task',
      noProjectsFound: 'No projects found.',
      actions: 'Actions',
      noItemsFound: 'No items found',
      nameCannotBeEmpty: 'Name cannot be empty',
      taskNameIsRequired: 'Task name is required',
      taskCreatedSuccessfully: 'Task created successfully',
      failedToCreateTask: 'Failed to create task',
      newProject: 'New Project',
      backToPersonal: 'Back to My Projects',
      bottomActionBar: {
        selected: '{{count}} selected',
        moveTasks: 'Move {{count}} task(s)',
      },
      templates: {
        projects: {
          name: 'Projects',
          description:
            'General project management with tasks, status tracking, and team assignments',
        },
        crm: {
          name: 'CRM',
          description:
            'Customer relationship management for contacts, leads, and organizations',
        },
        purchase: {
          name: 'Purchase',
          description:
            'Track purchase orders, vendors, pricing, and delivery status',
        },
        calendar: {
          name: 'Calendar',
          description:
            'Schedule meetings, events, and track attendee responses',
        },
        email: {
          name: 'Email',
          description:
            'Track email campaigns, drafts, and communication history',
        },
        repository: {
          name: 'Repository',
          description:
            'Document repository with file tracking and access management',
        },
        inventory: {
          name: 'Inventory',
          description:
            'Track inventory items, stock levels, and supplier information',
        },
      },
      delete: 'Delete {{type}}',
      deleteConfirmation: 'Are you sure you want to delete this {{type}}?',
      hubspot: {
        notConfigured:
          'HubSpot sync is not configured for this project. Configure it in project settings.',
        syncing: 'Syncing with HubSpot...',
        syncComplete: 'HubSpot sync completed successfully',
        syncFailed: 'HubSpot sync failed',
        syncError: 'Failed to sync with HubSpot',
      },
      fileSizeLimitError: 'Total file size must not exceed {{limit}} MB.',
      onlyOneFileAllowed: 'Only one file is allowed for upload.',
      unsupportedFileType: 'Unsupported file type: {{fileType}}.',
      columns: {
        title: 'Columns',
        createNew: 'Create New Column',
        add: 'Add Column',
        hide: 'Hide',
        sortAsc: 'Sort Ascending',
        sortDesc: 'Sort Descending',
        manageOptions: 'Manage Options',
        deleteTitle: 'Delete Column',
        deleteConfirm:
          'Are you sure you want to delete the column "{{title}}"?',
        resize: 'Resize',
        fixed: 'Fixed',
        default: 'Default',
        custom: 'Custom',
        allColumns: 'All columns',
        selectedCount: '({{count}} selected)',
        search: 'Search columns...',
        noColumnsFound: 'No columns found',
        reset: 'Reset Columns',
        moveLeft: 'Move Left',
        moveRight: 'Move Right',
      },
      cells: {
        select: {
          selectOption: 'Select option...',
          editOptions: 'Edit Options',
          deselect: 'Deselect',
        },
        people: {
          addPeople: 'Add people...',
          searchUsers: 'Search users...',
          noUsersFound: 'No users found',
          unknownUser: 'Unknown',
          failedToUpdate: 'Failed to update people assignment',
        },
        date: {
          selectDate: 'Select date',
        },
      },
      projectDataActions: {
        title: 'Data Tools',
        importCsv: 'Import CSV',
        exportCsv: 'Export to CSV',
        downloadTemplate: 'Download CSV Template',
        currentProjectTemplate: 'Current Project',
        selectTemplateTitle: 'Download CSV Template',
        orSelectTemplate: 'or select a template type',
        noItemsForExport: 'No items available for export',
        exportedCsvFile: 'Exported CSV file with {{count}} items',
        exportFailed: 'Failed to export items',
        noFileSelected: 'No file selected',
        csvDataUploadedSuccessfully: 'CSV data uploaded successfully!',
        failedToUploadCsvData: 'Failed to upload CSV data',
        noValidDataFound: 'No valid data found in CSV file',
        failedToProcessColumnSelection: 'Failed to process column selection',
        failedToParseCSV: 'Failed to parse CSV file',
        failedToUploadProjectsAndColumnData:
          'Failed to upload projects and column data',
        csvUploadRequirements: 'CSV Upload Requirements',
        csvUploadDescription:
          'Please make sure your CSV file has a header column named "Name" of type "text". This column is required and all names must be unique and non-empty.',
        continue: 'Continue',
        supportedFileTypes: 'Supported file types: .csv',
        missingColumnsDetected: 'Missing Columns Detected',
        missingColumnsDescription:
          "The following columns from your CSV don't exist in this project. Would you like to create them?",
        selectAll: 'Select All',
        type: 'Type: {{type}}',
        selectColumnsToCreate: 'Select Columns to Create',
        continueToPreview: 'Continue to Preview',
        skipAllMissingColumns: 'Skip All Missing Columns',
        confirmCsvUpload: 'Confirm CSV Upload',
        columnsToBeCreated: 'Columns to be Created',
        skippedColumns: 'Skipped Columns',
        createColumnsAndUpload: 'Create Columns & Upload {{count}}',
        upload: 'Upload {{count}}',
        uploadDescription: 'This will upload {{count}}.',
        createColumnsDescription:
          'This will create {{count}} new column{{plural}} and upload {{uploadCount}}.',
        newColumnHeader: '✨ {{header}} [NEW]',
        usersAssigned: '{{count}} user{{plural}} assigned',
        invalidUserData: 'Invalid user data',
        csvMustHaveTwoHeaderRows:
          'CSV must have at least two header rows (names and types)',
        csvMustContainHeadersAndTypes: 'CSV must contain headers and types',
        invalidColumnType:
          'Invalid column type "{{type}}". Valid types are: {{validTypes}}. Make sure your CSV file is correctly formatted.',
        personalProjectsCannotHavePeopleColumns:
          'Personal projects cannot have "people" type columns',
        csvMustContainNameColumn:
          'CSV must contain a "Name" column. This column is required for creating projects/tasks.',
        nameColumnMustBeText: 'The "Name" column must be of type "text".',
        nameColumnValidationFailed:
          'Name column validation failed:\n{{errors}}',
      },
      modals: {
        createProject: {
          title: 'Create New Project',
          placeholder: 'Enter project name',
          projectName: 'Project Name',
          selectTemplate: 'Select Template',
          loadingTemplates: 'Loading templates...',
          errorEmpty: 'Project name cannot be empty',
          errorCreate: 'Failed to create project: {{error}}',
          syncHubSpot: 'Sync with HubSpot',
          hubspot: {
            syncInfo: 'Contacts from HubSpot will be imported to this project.',
            connectedTo: 'Connected to: {{portalName}}',
            syncing: 'Importing contacts from HubSpot...',
            syncComplete: 'Contacts imported from HubSpot successfully',
            syncFailed: 'Contacts will sync on next manual sync',
            syncConfigFailed:
              'Project created but HubSpot sync configuration failed',
          },
        },
        selectOptions: {
          newLabel: 'New Label',
          editTitle: 'Edit "{{title}}" Options',
          saveChanges: 'Save Changes',
          addNewLabel: 'Add new label',
          deactivate: 'Deactivate',
          activate: 'Activate',
          updateSuccess: 'Options updated successfully!',
          updateFailed: 'Failed to update options: {{error}}',
        },
        taskDownload: {
          title: 'Download Models',
          download: 'Download',
          downloading: 'Downloading',
          error: 'Failed to download models.',
          noModels: 'No models available for download',
          unknownSize: 'Unknown size',
        },
      },
      uploadTask: 'Upload new task: ',
      taskName: 'Task Name',
      dragAndDrop: 'Browse or drop your files here',
      uploading: 'Uploading...',
      supportedTaskFiles:
        'Supported file types: glb, gltf, stl, step, jpg, png, webp, mp4, mov, pdf',
      paywall: {
        admin_message:
          'Please check with your organization admin to upgrade to be able to access team projects.',
        cta_button: 'Upgrade to use team features',
        no_access_message: 'Please contact your organization administrator.',
        max_reached: {
          heading: 'Subscription Seat Limit Reached',
          description:
            'Your organization has reached the maximum number of users allowed by your current subscription plan. Please upgrade your subscription to add more team members.',
          button_text: 'Upgrade Subscription',
          admin_message:
            'Your organization has reached the user limit. Please contact your administrator to upgrade the subscription plan.',
          no_access_message: 'Please contact your administrator to let you in.',
        },
        subscription_required: {
          heading: 'Subscription Required',
          description:
            'To access team projects and collaborate with your organization, you need an active subscription.',
        },
      },
      noProjectsFound:
        'No project found. Create your first project to get started!',
      noProjectsFoundUser:
        'You don’t have access to any team projects. Please contact an admin to get invited',
      guidance_message:
        'Please select a task from the project list on the left.',
      reset_column_order: 'Reset columns',
      reset_column_order_confirm:
        'Are you sure you want to reset the columns? This will clear all sorting, size and column order settings.',
      no_actions: 'No actions available',
      toast: {
        add_project: 'Project added successfully.',
        add_project_error: 'Failed to add project.',
        delete_project: 'Project(s) deleted successfully.',
        delete_project_error: 'Failed to delete project(s).',
        rename_project: 'Project(s) renamed successfully.',
        rename_project_error: 'Failed to rename project(s).',
        empty_project_name: 'Please enter a project name.',
        delete_task: 'Task(s) deleted successfully.',
        delete_task_error: 'Failed to delete task(s).',
        download_task: 'Model(s) downloaded successfully.',
        download_task_error: 'Failed to download model(s).',
        duplicate_project: 'Project(s) duplicated successfully.',
        duplicate_project_error: 'Failed to duplicate project(s).',
        duplicate_task_limit:
          'You can only duplicate up to {{number}} tasks at a time.',
        duplicate_task: 'Task duplicated successfully.',
        duplicate_task_error: 'Failed to duplicate task.',
        move_task: 'Task(s) moved successfully.',
        move_task_error: 'Failed to move task(s).',
        copy_task: 'Task(s) copied successfully.',
        rename_task: 'Task renamed successfully.',
        rename_task_error: 'Failed to rename task.',
        delete_item: 'Items deleted successfully.',
        delete_item_error: 'Failed to delete items.',
        reset_view: 'View reset to default order.',
        email_copied: {
          title: 'Email copied',
          description: 'Email copied to clipboard successfully.',
        },
        failed_column_update: 'Failed to update column value',
        column_exists: 'Column name already exists',
      },
    },
    invitation: {
      invitation_error: 'Invitation Error',
      check_account: 'Please check your account',
      go_to_projects: 'Go to Projects',
      sign_out_button: 'Sign Out',
      invitation_process_title: 'Invitation Process',
      set_password_label: 'Set Password',
      password_placeholder: 'Enter your new password',
      save_password_button: 'Save Password',
      process_completed: 'Process Completed',
      go_to_team_projects: 'Go to Team Projects',
      go_to_login: 'Go to Login',
      password_min_length: 'Password must be at least 5 characters long',
      password_created_success: 'Password created successfully!',
      password_creation_failed: 'Failed to create password. Please try again.',
    },
    SubmittedForms: {
      title: 'Submitted Forms',
      no: 'No.',
      type: 'Type',
      description: 'Description',
      firstName: 'First Name',
      lastName: 'Last Name',
      requestDate: 'Request Date',
      updatedDate: 'Updated Date',
      status: 'Status',
      noOrganization: 'No Organization',
      noSubmittedFormsFound: 'No submitted forms found',

      toast: {
        statusUpdatedSuccessfully: 'Submitted form status updated successfully',
        statusUpdateFailed: 'Failed to update submitted form status',
        loadFailed: 'Failed to load submitted forms',
        submissionFailed: 'Failed to submit form',
        missingFields: 'Please fill in all required fields',
        invalidEmail: 'Please enter a valid email address',
        quotationSubmittedSuccessfully: 'Quotation submitted successfully',
      },
    },
    help: {
      title: 'Help & Support',
      subtitle: 'Find answers to common questions and get support',
      account_management: {
        title: 'Account Management',
        delete_account: {
          title: 'How to delete your account',
          content:
            'To delete your account, go to Settings > Account > Delete Account. Please note that this action is irreversible and will permanently remove all your data.',
        },
        update_info: {
          title: 'Updating account information',
          content:
            'You can update your account information at any time by visiting Settings > Account > Edit Profile.',
        },
        password_reset: {
          title: 'Password reset',
          content:
            'If you forgot your password, click on "Forgot Password" on the login page. You will receive an email with instructions to reset your password.',
        },
      },
      general_usage: {
        title: 'General Usage',
        view_cad: {
          title: 'Viewing CAD files',
          content:
            'To view CAD files, simply drag and drop them into the viewer or use the upload button. Supported formats include .dwg, .dxf, and .stl.',
        },
        navigation: {
          title: 'Navigation controls',
          content:
            'Use your mouse to navigate: Left click to rotate, right click to pan, and scroll to zoom. Touch controls are also supported on mobile devices.',
        },
        save_export: {
          title: 'Saving and exporting',
          content:
            'You can save your current view and export files in various formats using the toolbar at the top of the viewer.',
        },
      },
      support: {
        title: 'Getting Support',
        contact: {
          title: 'Contact support',
          content:
            'For technical issues or questions, please email {{email}} or use our contact form.',
        },
        documentation: {
          title: 'Documentation',
          content:
            'Visit our documentation site for detailed guides and tutorials.',
        },
        community: {
          title: 'Community forum',
          content:
            'Join our community forum to connect with other users and share tips and tricks.',
        },
      },
      privacy: {
        title: 'Privacy Policy',
        link: {
          title: 'Learn more',
          content:
            'Visit our privacy policy page for more information on how we handle your data.',
        },
      },
      more_help: {
        title: 'Need more help?',
        email: 'Email Support',
        docs: 'Documentation',
        forum: 'Community Forum',
      },
    },
    settings: {
      title: 'Settings',
      tabs: {
        personal: 'Personal',
        organization: 'Organization',
        subscription: 'Subscription',
        settings: 'Settings',
      },
      header: {
        account_owner: 'Account Owner',
      },
      personal_details: {
        title: 'Personal Details',
        created_at: 'Created At',
        change_password: 'Change',
        saving: 'Saving...',
      },
      preferences: {
        title: 'Preferences',
        language: 'Language',
        default_space: 'Default Space',
        select_language: 'Select language',
        select_default_space: 'Select default space',
        languages: {
          en: 'English',
          kr: '한국어',
        },
        spaces: {
          select: 'Select Space',
          collaboration: 'Collaboration',
          robotics: 'Robotics',
        },
      },
      delete_account: {
        title: 'Delete Account',
        description:
          'Once you delete your account, there is no going back. Please be certain.',
        button: 'Delete Account',
        modal: {
          title: 'Delete Account',
          confirm_title: 'Are you sure you want to delete your account?',
          warning: 'This action cannot be undone',
          description: 'All of your data will be permanently removed.',
          confirm: 'Delete Account',

          deleting: 'Deleting...',
        },
      },
      organization: {
        title: 'My Organizations',
        subtitle: 'Manage your organization settings and memberships',
        create_or_join: 'Create or Join Organization',
        empty_state: {
          title: 'No organizations found',
          description:
            'Get started by creating your first organization or joining an existing one.',
          button: 'Create or Join Organization',
        },
      },
      modals: {
        update_password: {
          title: 'Update Password',
          current_password: 'Current Password',
          new_password: 'New Password',
          confirm_password: 'Confirm New Password',
          update: 'Update Password',
        },
        otp_verification: {
          title: 'Phone Verification',
          description: 'Enter the verification code sent to your phone',
          verify: 'Verify',
        },
        edit_avatar: {
          title: 'Edit Avatar',
          upload_new: 'Upload New Image',
          save: 'Save Changes',
          organization_description:
            'Upload a new organization logo. The image should be square and at least 200x200 pixels.',
          user_description:
            'Upload a new avatar image. The image should be square and at least 200x200 pixels.',
        },
        add_user: {
          title: 'Add New Member',
          description: 'Invite a new member to join your organization',
          role: 'Role',
          first_name_placeholder: 'Enter first name',
          last_name_placeholder: 'Enter last name',
          email_placeholder: 'Enter email address',
          add_user: 'Add User',
          adding: 'Adding...',
          upgrade_required: 'Upgrade Required',
          upgrade_seats: 'Upgrade Seats',
          max_users_warning:
            'You have reached the maximum number of users ({{current}}/{{max}}). Please upgrade your plan to add more users.',
        },
        delete_organization: {
          title: 'Delete Organization',
          warning:
            'Are you sure you want to delete "{{name}}"? This action cannot be undone and all organization data will be permanently removed.',
          confirmation_label: 'Type "DELETE" to confirm:',
          confirmation_placeholder: 'Type DELETE to confirm',
          confirm_delete: 'Delete Organization',
          deleting: 'Deleting...',
          type_delete_error: 'Please type "DELETE" to confirm',
        },
        subscription_confirmation: {
          title: 'Subscription Updated Successfully!',
          message: 'Your subscription has been successfully updated on PayPal.',
          email_notice:
            'You will receive an email once the changes take effect.',
        },
      },
      user_management: {
        table: {
          role: 'Role',
          date_joined: 'Date Joined',
          actions: 'Actions',
          no_users_found: 'No users found',
        },
        actions: {
          add_member: 'Add Member',
          action_required: 'Action Required',
          pending: 'Pending',
          approve: 'Approve',
          deny: 'Deny',
          resend: 'Resend',
        },
        status: {
          max_users_exceeded: 'Max users exceeded {{current}}/{{max}}',
        },
      },
      invoice_history: {
        title: 'Invoices',
        table: {
          date: 'Date',
          description: 'Description',
          invoice_total: 'Invoice Total',
          invoice: 'Invoice',
          download_pdf: 'Download PDF',
          no_invoice: 'No invoice',
        },
        loading: 'Loading...',
        error: 'Error loading invoices. Please try again.',
        no_billing_history: 'No billing history available',
        no_invoices: 'No invoices available',
        generating_pdf: 'Generating invoice PDF...',
        pdf_generated: 'Invoice PDF downloaded successfully',
        pagination: {
          previous: 'Previous',
          next: 'Next',
          page_of: 'Page {{current}} of {{total}}',
        },
      },
      organization_details: {
        organization: 'Organization',
        subscription: 'Subscription',
        invoices: 'Invoices',
        date_created: 'Date Created',
        organization_name: 'Organization Name',
        organization_id: 'Organization ID',
        leave_organization: 'Leave Organization',
        cancel_request: 'Cancel Request',
        delete_organization: 'Delete Organization',
        user_management: 'User Management',
        subscription_required: {
          title: 'Subscription Required',
          message:
            'A paid subscription is required to access advanced organization features.',
          button: 'Subscribe',
        },
        pending_approval: {
          title: 'Pending Approval',
          message:
            'Your request to join this organization has been sent to the administrator. Please wait for approval.',
        },
        leave_confirmation: {
          title: 'Leave Organization',
          message:
            'Are you sure you want to leave "{{name}}"? This action cannot be undone.',
        },
      },
      notifications: {
        title: 'Notification Settings',
        subtitle: 'Manage your notification preferences',
        pushNotifications: {
          label: 'Push Notifications',
          description:
            'Enable alerts to stay informed about important activity.',
          toast: {
            enabled: 'Push notifications enabled successfully.',
            disabled: 'Push notifications disabled successfully.',
            enable_failed: 'Failed to enable push notifications.',
            disable_failed: 'Failed to disable push notifications.',
          },
        },
        notificationVibration: {
          label: 'Notification Vibration',
          description: 'Vibrate your device when a new notification arrives.',
          toast: {
            enabled: 'Notification vibrations enabled.',
            disabled: 'Notification vibrations disabled.',
            enable_failed: 'Failed to enable notification vibrations.',
            disable_failed: 'Failed to disable notification vibrations.',
          },
        },
        notificationSound: {
          label: 'Notification Sound',
          description: 'Play a sound whenever you receive a notification.',
          toast: {
            enabled: 'Notification sounds enabled.',
            disabled: 'Notification sounds disabled.',
            enable_failed: 'Failed to enable notification sounds.',
            disable_failed: 'Failed to disable notification sounds.',
          },
        },
      },
      integrations: {
        google: {
          title: 'Google Integration',
          subtitle:
            'Connect your Google account to send emails and schedule meetings using the AI assistant.',
          loading: 'Loading...',
          connected: 'Connected',
          not_connected: 'Not connected',
          connect: 'Connect Google Account',
          disconnect: 'Disconnect',
          disconnected: 'Google account disconnected successfully.',
          connect_error: 'Failed to connect Google account',
          disconnect_error: 'Failed to disconnect Google account',
          features_title: 'Available features:',
          feature_email: 'Send emails via Gmail',
          feature_calendar: 'Create and manage calendar events',
          feature_meet: 'Schedule meetings with Google Meet',
        },
        hubspot: {
          title: 'HubSpot Integration',
          subtitle:
            'Connect your HubSpot account to sync CRM data with your projects',
          loading: 'Checking connection...',
          connected: 'Connected',
          connected_toast: 'HubSpot account connected',
          not_connected: 'Not connected',
          connect: 'Connect HubSpot',
          disconnect: 'Disconnect',
          disconnected: 'HubSpot account disconnected',
          connect_error: 'Failed to connect to HubSpot',
          disconnect_error: 'Failed to disconnect HubSpot account',
          features_title: 'Available features:',
          feature_contacts: 'Sync Contacts',
        },
      },
      invoice_pdf: {
        generating_pdf: 'Generating invoice PDF...',
        pdf_generated: 'Invoice PDF downloaded successfully',
        tokens: 'tokens',
        token: 'token',
        seats: 'seats',
        seat: 'seat',
        not_available: 'N/A',
        token_purchase: 'Token Purchase',
        plan_change: 'Plan Change',
        upgraded_to: 'Upgraded to',
        downgraded_to: 'Downgraded to',
        with_proration: 'with proration',
        free_upgrade: 'Free upgrade - no charge',
        free_downgrade: 'Free downgrade - no charge',
        organization: 'Organization',
        invoice: 'INVOICE',
        bill_to: 'BILL TO:',
        invoice_number: 'Invoice Number:',
        transaction_id: 'Transaction ID:',
        date: 'Date:',
        payment_period: 'Payment Period:',
        total: 'TOTAL:',
        thank_you: 'Thank you for your business!',
        page_footer: 'Page {{current}} of {{total}}',
        service: 'SERVICE',
        period: 'PERIOD',
        unit_fee: 'UNIT FEE',
        invoice_default: 'invoice',
        filename_prefix: 'invoice',
      },
      toast: {
        info_updated: 'Your information has been successfully updated.',
        info_update_failed:
          'Failed to update your information. Please try again.',
        invalid_fields: 'Please fix the invalid fields before saving.',
        language_updated: 'Language preference updated successfully',
        language_update_failed: 'Failed to update language preference',
        space_updated: 'Default space preference updated successfully',
        space_update_failed: 'Failed to update space preference',
        account_deleted: 'Account deleted successfully',
        account_delete_failed: 'Failed to delete account',
        otp_send_failed: 'Failed to send OTP. Please try again.',
        general_error: 'An error occurred while updating your information.',
        user_invited: 'User invited: {{email}}',
        user_invite_failed: 'Failed to invite user',
        user_role_updated: 'User role updated successfully',
        user_role_update_failed: 'Failed to update user role',
        user_approved: 'User approved successfully',
        user_approve_failed: 'Failed to approve user',
        user_removed: 'User removed successfully',
        user_remove_failed: 'Failed to remove user',
        invitation_resent: 'Invitation resent successfully',
        invitation_resend_failed: 'Failed to resend invitation',
        organization_updated: 'Organization updated successfully',
        organization_update_failed: 'Failed to update organization',
        organization_deleted: 'Organization deleted successfully',
        organization_delete_failed: 'Failed to delete organization',
        organization_left: 'Successfully left the organization',
        organization_leave_failed: 'Failed to leave organization',
        organization_name_required: 'Organization name is required',
        invoice_download_failed: 'Failed to download invoice',
        users_load_failed: 'Failed to load users',
        upgrade_seats_info:
          'Please navigate to the subscription tab to upgrade your plan',
        validation_errors: {
          first_name_required: 'Please enter a valid first name',
          last_name_required: 'Please enter a valid last name',
          email_required: 'Please enter a valid email address',
        },
      },
    },
    privacy: {
      title: 'Luxolis - Privacy Policy',
      lastUpdated: 'Last updated: April 21, 2025',
      whoAreWe: 'Who are we?',
      whoAreWeContent:
        'We, LuxPM Co., Ltd., Business Registration Number 549-81-01935, with registered offices in South Korea, are committed to protecting your personal data. This Privacy Policy outlines how we collect, process, use, and safeguard your information when you interact with our services, including the O-HIVE platform.',
      regulations: 'Which regulations do we follow?',
      regulationsContent:
        'We comply with all applicable laws and regulations in South Korea, including the Personal Information Protection Act (PIPA), the Act on the Promotion of Information and Communications Network Utilization and Information Protection, and any other related domestic regulations. For international users, we also adhere to best practices aligned with global privacy standards.',
      dataProcessing: {
        title: '1. WHY AND HOW DO WE PROCESS YOUR DATA?',
        reasons: [
          {
            title: 'To provide our services.',
            content:
              "We process your personal data to fulfill contractual obligations and deliver the services you've subscribed to.",
          },
          {
            title: 'User account creation and management.',
            content:
              'Your personal data is used to create and maintain your user account on our platform.',
          },
          {
            title: 'Service functionality.',
            content:
              'To ensure smooth usage of the O-HIVE platform and our website, your data is processed based on our legitimate interest in service reliability and performance.',
          },
          {
            title: 'Legal claims.',
            content:
              'We may process personal data to protect our legal rights and ensure compliance with regulatory requirements.',
          },
          {
            title: 'Newsletters and updates.',
            content:
              'With your consent, we may use your contact information to send updates or promotional materials. You can opt out at any time.',
          },
          {
            title: 'Compliance obligations.',
            content:
              'We may process personal data in accordance with legal obligations under South Korean law, including those related to telecommunications sales reporting and e-commerce.',
          },
          {
            title: 'Customer support.',
            content:
              'We process personal data to handle support requests and improve our user experience.',
          },
          {
            title: 'Analytics.',
            content:
              'To enhance our services, we analyze usage patterns based on legitimate interest. Data is anonymized where applicable.',
          },
          {
            title: 'Marketing.',
            content:
              'With your explicit consent, we may process data to personalize and improve our marketing efforts.',
          },
          {
            title: "Children's data.",
            content:
              'Our services are not intended for individuals under the age of 14. We do not knowingly collect personal information from children. If we become aware that we have inadvertently collected such data, we will take steps to delete it promptly.',
          },
        ],
      },
      personalData: {
        title: '2. WHAT PERSONAL DATA DO WE PROCESS?',
        intro: 'We may collect the following categories of data:',
        categories: [
          {
            title: 'Identification Data:',
            content: 'Name, email address, password',
          },
          {
            title: 'Contact Data:',
            content: 'Phone number, address',
          },
          {
            title: 'Transaction Data:',
            content: 'Payment records, transaction dates and amounts',
          },
          {
            title: 'Device & Network Identifiers:',
            content: 'IP address, device ID, cookies',
          },
          {
            title: 'Communication Data:',
            content: 'Messages, user interactions, survey responses',
          },
        ],
      },
      dataRetention: {
        title: '3. DATA RETENTION',
        intro:
          'We retain your data only for as long as needed to fulfill the purposes described:',
        periods: [
          {
            title: 'User accounts:',
            content: 'Retained while the account is active',
          },
          {
            title: 'Legal claims or disputes:',
            content:
              'Retained through the duration of the case and the applicable limitation period',
          },
          {
            title: 'Newsletters:',
            content: 'Retained until you opt out, but no longer than 2 years',
          },
          {
            title: 'Analytics:',
            content: 'Retained up to 5 years or until consent is withdrawn',
          },
          {
            title: 'Legal obligations:',
            content: 'Retained as required by law',
          },
        ],
      },
      dataSharing: {
        title: '4. DATA SHARING & TRANSFER',
        points: [
          {
            title: 'Processors:',
            content:
              'We work with third-party service providers who process data under our instructions (e.g., IT service providers, analytics tools).',
          },
          {
            title: 'Controllers:',
            content:
              'Your data may be shared with payment processors (e.g., PayPal, Braintree) where applicable.',
          },
          {
            title: 'International Transfers:',
            content:
              'If data is transferred outside of South Korea, we ensure such transfers meet the required safeguards under applicable regulations.',
          },
        ],
      },
      yourRights: {
        title: '5. YOUR RIGHTS',
        intro: 'As a data subject, you may:',
        rights: [
          'Request access to your data',
          'Request corrections',
          'Request deletion, if applicable',
          'Object to or restrict processing',
          'Withdraw consent at any time',
          'Request data portability (where technically feasible)',
        ],
        contact: 'To exercise these rights, contact us at:',
      },
      cookies: {
        title: '6. COOKIES',
        pointTitle1: 'We use cookies to:',
        pointList1: [
          'Remember your preferences',
          'Enable login sessions',
          'Improve user experience and analytics (e.g., Google Analytics)',
        ],
        pointTitle2:
          "You can manage cookie settings through your browser or our site's cookie control tools.",
      },
      contact: {
        title: 'Contact Information',
        company: 'LuxPM Co., Ltd.',
        reportNumber: 'Telecommunications Sales Report No: 2022-성남분당C-0435',
        address1:
          'Business Address: #412, Building C 1121, H Business Park, 645 Munjeong-dong, Songpa-gu, Seoul',
        address2: '서울시 송파구 문정동645 H비지니스파크 A동412호',
      },
    },
    publicModels: {
      title: 'Luxolis 3D Vision & Robotics Marketplace (Product Catalog)',
      description:
        'Explore real-world 3D projects and solutions. Showcase, sell, or book products and services with powered by cutting-edge 3D vision technology.',
    },
    pricing: {
      title: 'Pricing & Subscriptions',
      subtitle: 'Choose the plan that best fits your needs',
      loading: 'Loading subscription data...',
      select_plan: 'Select your plan',
      switch_to_plan: 'Switch to {{planName}} plan',
      manage: 'Manage Subscription',
      switch_to_free: 'Switch to Free',
      current_plan: 'Current Plan',
      resubscribe: 'Resubscribe',
      no_changes: 'No changes made',
      continue_payment: 'Continue to Payment',
      subscribe_with_card: 'Subscribe with Card',
      processing: 'Processing...',
      payment_methods_title: 'Payment Methods',
      paypal: 'PayPal',
      credit_card: 'Credit Card',
      card_coming_soon: 'Card coming soon',
      login_prompt: 'Please login to subscribe to a plan',
      login_credit_prompt: 'Please login to purchase credits',
      manage_subscription: 'Manage Subscription',
      subscription_context: 'Select subscription context:',
      personal: 'Personal',
      organization: 'Organization',
      free_plan: 'Free',
      basic_plan: 'Basic',
      team_plan: 'Team',
      enterprise_plan: 'Enterprise',
      what_included: "What's included",
      show_all_features: 'Show all features',
      hide_features: 'Hide features',
      feature_access: 'Feature Access',
      seats: 'seats',
      seat: 'seat',
      current_seats: 'Current seats',
      select_bundle: 'Select bundle:',
      buy_now: 'Buy Now',
      login_to_purchase: 'Login to Purchase',
      plan: 'Plan',
      with_credits: 'with {{credits}} Credits',
      credit_bundles: 'Credit Bundles',
      monthly_recurring: 'monthly recurring billing',
      contact_us: 'Contact Us',
      select_context: 'Select context...',
      organizations: 'Organizations',
      unknown_organization: 'Unknown Organization',
      create_new: 'Create new organization',
      confirmation: {
        success_title: 'Subscription Successful!',
        success_message: 'Your subscription has been updated successfully.',
        subscription_details_org:
          'You have subscribed to <b style="color: #111827">{{count}}</b> seats on <b style="color: #111827">{{planName}}</b> plan for <b style="color: #111827">{{orgName}}</b>.',
        subscription_details_personal:
          'You have subscribed to <b style="color: #111827">{{count}}</b> seat on <b style="color: #111827">{{planName}}</b> plan.',
        subscription_details_personal_no_seats:
          'You have subscribed to <b style="color: #111827">{{planName}}</b> plan.',
      },
      proration: {
        title: 'Prorated Charge Details',
        description: 'Additional charge for immediate seat increase',
        amount: 'Prorated amount: ${{amount}}',
        billing_note: 'This will be added to your current billing cycle.',
        description_details:
          "You'll be charged ${{amount}} for {{seats}} additional seat(s) for the remaining {{days}} days in your current billing period.",
      },
      modals: {
        subscription: {
          title: 'Subscribe to Plan',
          manage_title: 'Manage Subscription',
          upgrade_title: 'Upgrade Subscription',
          downgrade_title: 'Downgrade Subscription',
          resubscribe_title: 'Resubscribe to Plan',
          back: 'Back',
          continue: 'Continue to Payment',
          cancel_subscription: 'Cancel Subscription',
          already_cancelled: 'Subscription already scheduled for cancellation',
          no_change_needed: 'No changes needed',
          manage_seats_title: 'Manage seats',
          complete_payment_title: 'Complete payment',
          add_seats: 'Add {{count}} seat',
          add_seats_plural: 'Add {{count}} seats',
          remove_seats: 'Remove {{count}} seat',
          remove_seats_plural: 'Remove {{count}} seats',
          update_seats: 'Update seats',
        },
        cancel_subscription: {
          title: 'Cancel Subscription',
          message: 'Are you sure you want to cancel your subscription?',
          warning:
            'This action cannot be undone. Your subscription will remain active until the end of the current billing period.',
          keep_subscription: 'Keep Subscription',
          cancel_subscription: 'Cancel Subscription',
          processing: 'Processing...',
        },
      },
      toast: {
        subscription_updated: 'Subscription updated successfully',
        subscription_cancelled: 'Subscription cancelled successfully',
        subscription_failed: 'Failed to update subscription',
        cancellation_failed: 'Failed to cancel subscription',
        payment_success: 'Payment completed successfully',
        payment_failed: 'Payment failed. Please try again.',
        credits_purchased:
          'Credits purchased successfully! {{credits}} credits have been added to your account.',
        credits_failed: 'Failed to purchase credits',
        plan_not_available_org:
          'Team and Enterprise plans require an organization. Please switch to the Organization tab.',
        plan_not_available_personal:
          'Personal plans are only available in the Personal tab.',
        login_required: 'Please login to subscribe',
        switch_context_failed: 'Failed to switch subscription context',
        refresh_failed: 'Failed to refresh subscription data',
        loading_failed: 'Failed to load pricing data',
        payment_error: 'Something went wrong during payment. Please try again.',
        payment_update_failed:
          'Payment succeeded but failed to update account. Please refresh the page.',
        subscriptions_load_failed: 'Failed to load available subscriptions',
      },
      plans: {
        free: {
          name: 'Free',
          description: 'Best for personal projects',
          period: '/Month',
          user_limit: '1 User Limit',
          credit_based_access: 'Credit Based Access To:',
          features: {
            file_management: 'File management & preview',
            notifications: 'Notifications (individual projects)',
            multi_format_upload:
              'Multi-format data upload (2D, 3D, video, panorama)',
            model_annotation: 'Model annotation and export',
            unlimited_tasks: 'Unlimited tasks & projects',
            storage: '10 GB of free storage',
          },
        },
        professional: {
          name: 'Professional',
          description: 'Best for AI & Automation',
          period: '/Month',
          user_limit: '1 User Limit',
          feature_groups: {
            everything_free: 'Everything in Free +',
            ai_features: 'AI Features',
            capture_features: 'Capture Features',
            '3d_features': '3D Features',
          },
          features: {
            credits: '1000 Credits',
            ohive_assistant: 'O-HIVE Assistant',
            model_training: 'Model Training',
            object_detection: 'Object Detection',
            document_analysis: 'Document Analysis',
            smart_summaries: 'Smart Summaries',
            scene_scan: '3D Scene Scan',
            object_scan: 'Object Scan',
            video_capture: 'Video Capture',
            image_capture: 'Image Capture',
            blueprint: 'Blueprint',
            merging_cropping: 'Merging & Cropping',
            panorama: 'Panorama',
            multiple_objects: 'Multiple Objects in One Scene',
          },
        },
        team: {
          name: 'Team',
          description: 'Best for team collaboration and Automation',
          period: '/ Seat / Month',
          user_limit: '2–10 Users',
          feature_groups: {
            everything_professional: 'Everything in Professional +',
            collaboration_features: 'Collaboration Features',
            team_features: 'Team Features',
          },
          features: {
            collaboration_tools: 'Team Collaboration Tools',
            multi_user_access: 'Multi-user organization access',
            seat_management: 'Seat management',
            roles: 'Roles (Admin, Member, Guest)',
            sharing_assignment: 'Sharing and task assignment',
            commenting_tagging: 'Dynamic Commenting & Tagging',
            analytics_dashboard: 'Team Analytics Dashboard',
            workflow_automation: 'Workflow Automation',
            premium_support: 'Premium Support',
          },
        },
        enterprise: {
          name: 'Enterprise',
          description: 'Best for large projects',
          period: '/ Seat / Month',
          user_limit: '10–25 Users',
          bigger_team_note:
            "Planning for a bigger team? We'd love to tailor a solution for you.",
          feature_groups: {
            everything_team: 'Everything in Team & Professional',
          },
          features: {
            priority_access: 'Priority Access to New Features',
          },
        },
      },
      bundles: {
        starter: {
          name: 'Starter',
          description: 'Perfect for small projects',
        },
        professional: {
          name: 'Professional',
          description: 'Perfect for regular use',
        },
        enterprise: {
          name: 'Enterprise',
          description: 'Best value for large projects',
        },
      },
      subscription_details: {
        title: 'Subscription Details',
        plan_name: 'Plan Name',
        status: 'Status',
        billing_cycle: 'Billing Cycle',
        seats: 'Seats',
        next_billing: 'Next Billing',
        amount: 'Amount',
        expires_on: 'Expires On',
        renewal_date: 'Renewal Date',
        active: 'Active',
        cancelled: 'Cancelled',
        expired: 'Expired',
        monthly: 'Monthly',
        yearly: 'Yearly',
        credit_balance: 'Credit Balance',
        current_seats: 'Current Seats',
        desired_seats: 'Desired Seats',
        billing_date: 'Billing Date',
        next_billing_date: 'Next Billing Date',
        billing_amount: 'Billing Amount',
        next_billing_amount: 'Next Billing Amount',
      },
      seat_selector: {
        seats: 'seats',
        current_plan: 'CURRENT PLAN',
        new: 'NEW',
        seat_billed_monthly: 'Each seat billed ${{price}} /month',
        add_seats: 'Add Seats',
      },
      billing_info: {
        billing_summary: 'Billing Summary',
        plan: 'Plan',
        seats: 'Seats',
        subtotal: 'Subtotal',
        total: 'Total',
        monthly_total: '${{amount}} USD/month',
        prorated_charge: 'Prorated charge for additional seats',
        billing_note: 'Prorated amount will be charged immediately.',
        next_charge: 'Next Charge',
        cancel_note: 'You can cancel anytime.',
        new_monthly_plan: 'New monthly plan from',
        seats_on_plan: '{{quantity}} Seats on {{planName}}',
        tax: 'Tax',
      },
      paypal: {
        title: 'PayPal',
        approval_required: 'PayPal Approval Required',
        creating_order: 'Creating PayPal order...',
        redirecting: 'Redirecting to PayPal',
        redirect_message:
          'You will be redirected to PayPal to complete your payment.',
        manual_redirect: 'Click here if you are not redirected',
        approval_context: 'Complete your subscription payment through PayPal',
        loading_error: 'PayPal Loading Error',
        retry: 'Retry',
        complete_purchase: 'Complete Purchase',
        purchasing: 'Purchasing...',
        purchase_details:
          'Purchase details: {{credits}} credits for ${{price}}',
        processing_payment: 'Processing payment...',
        loading_paypal: 'Loading PayPal...',
        updating_subscription: 'Updating subscription...',
        finalizing_purchase: 'Finalizing purchase...',
      },
      notice: {
        proration_details_part1:
          "You'll be charged <b>{{amount}}</b> for {{count}} additional seat for the remaining",
        proration_details_part1_plural:
          "You'll be charged <b>{{amount}}</b> for {{count}} additional seats for the remaining",
        proration_details_part2:
          '{{count}} day in your current billing period. Your next regular payment of',
        proration_details_part2_plural:
          '{{count}} days in your current billing period. Your next regular payment of',
        proration_details_part3:
          '<b>{{amount}}</b> will be due on <b>{{date}}</b>.',
      },
      payment_step: {
        effective_immediately: 'This change is effective immediately',
        charge_text: 'Your card will be charged <b>${{amount}}</b> now',
        processing_payment: 'Processing payment...',
      },
      paypal_approval: {
        new_total_message:
          'Your new monthly subscription will be <b>${{newTotal}}</b>, effective from your next billing date.',
        redirect_message:
          'You are being redirected to PayPal to confirm this change. No immediate payment will be taken.',
      },
    },
  },
  components: {
    loginMessage: {
      message: 'access',
      loggedIn: 'logged in',
      mustBe: 'You must be ',
      postComment: 'post a comment',
      replyComment: 'reply to this comment',
    },
  },
  toast: {
    itemLoadsError: {
      title: 'Failed to load items',
      description:
        'First chunk of models did not complete within the expected time.',
    },
    uploadFilesError: {
      title: 'No Permission',
      description:
        'Upload failed: You do not have edit permissions on this file.',
    },
    uploadFilesError: {
      title: 'No Permission',
      description:
        'Upload failed: You do not have edit permissions on this file.',
    },
    changeTypeTeamError:
      'You need to select/join an organization to have team projects',
  },
  viewer: {
    vtProcessing: {
      title: 'Optimizing your model',
      description:
        'Your model is being optimized for texture streaming. This usually takes a few minutes.',
      checking: 'Checking status...',
      checkNow: 'Check now',
      complete: 'Model optimization complete! Loading...',
      failed: 'Model optimization failed. Reloading with original model...',
      failedDescription:
        'Optimization failed. The original model will be loaded instead.',
      errorGeneric: 'An error occurred during processing.',
      loadOriginal: 'Load original model',
      stillProcessing: 'Still processing... will check again shortly.',
      checkFailed: 'Could not check status. Will retry.',
      steps: {
        queued: 'Queued',
        downloading: 'Downloading model',
        validating: 'Validating model',
        processing: 'Processing textures',
        processingDesktop: 'Processing desktop profile',
        processingLow: 'Processing mobile profile',
        uploading: 'Uploading results',
        completed: 'Completed',
        failed: 'Failed',
      },
    },
  },
};
